import { useEffect, useRef } from 'react';
import { Controller, FieldValues, useController } from 'react-hook-form';

import ExtendedSearch from '@/components/search/v1/extendedSearch/ExtendedSearch';
import { FieldError } from '@/components/UI/Fields/FieldError';
import { FieldProps } from '@/components/UI/Fields/types';
import { Label } from '@/components/UI/Label/Label';

type ExtendedSearchFieldProps<T extends FieldValues> = FieldProps<T> &
  Omit<React.ComponentPropsWithoutRef<typeof ExtendedSearch>, keyof FieldProps<T>>;

export const ExtendedSearchField = <T extends FieldValues>({
  control,
  name,
  label,
  required,
  rules,
  defaultValues,
  ...rest
}: ExtendedSearchFieldProps<T>) => {
  const { fieldState } = useController<T>({
    name,
    control,
    rules: { required: required ? 'dit veld is verplicht' : undefined, ...rules },
  });

  const inputRef = useRef<HTMLInputElement>(null);

  // Verwijder initial focus van extended search in geavanceerd zoeken
  useEffect(() => {
    setTimeout(() => {
      inputRef.current!.blur();
    }, 0);
  }, []);

  return (
    <div>
      {label && <Label>{label}</Label>}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <ExtendedSearch
              defaultValues={defaultValues}
              onUserSearchIntent={field.onChange}
              ref={inputRef}
              {...rest}
            />
          )}
        />
        <FieldError width='auto' error={fieldState.error} />
      </div>
    </div>
  );
};
